import { render, staticRenderFns } from "./PharmacyExpenseCategory.vue?vue&type=template&id=db825c06"
import script from "./PharmacyExpenseCategory.vue?vue&type=script&lang=js"
export * from "./PharmacyExpenseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports